// src/hooks/useGroupedByWorkspace.js
import {useMemo} from 'react';

export const useGroupedByWorkspace = (projects) => {
  
  return useMemo(() => {
    const workspacesMap = {};

    if (!Array.isArray(projects)) {
      return { workspaces: [] };
    }

    projects.forEach((project) => {
      const workspaceId = project.workspaceId;
      if (workspaceId && workspaceId !== null && workspaceId !== undefined && workspaceId !== "") {
        if (!workspacesMap[workspaceId]) {
          workspacesMap[workspaceId] = {
            workspaceId: workspaceId,
            workspaceName: project.workspaceName || "Unnamed Workspace",
            projects: [],
          };
        }
        workspacesMap[workspaceId].projects.push(project);
      } else {
        const defaultWorkspaceId = "__no_workspace";
        if (!workspacesMap[defaultWorkspaceId]) {
          workspacesMap[defaultWorkspaceId] = {
            workspaceId: defaultWorkspaceId,
            workspaceName: "No Workspace",
            projects: [],
          };
        }
        workspacesMap[defaultWorkspaceId].projects.push(project);
      }
    });

    let workspacesArray = Object.values(workspacesMap);
    workspacesArray.sort((a, b) => {
      const aLatest = Math.max(
        ...a.projects.flatMap(project =>
          project.jobs.map(job => new Date(job.latestTimeStamp || 0).getTime())
        )
      );
      const bLatest = Math.max(
        ...b.projects.flatMap(project =>
          project.jobs.map(job => new Date(job.latestTimeStamp || 0).getTime())
        )
      );
      return bLatest - aLatest;
    });

    return { workspaces: workspacesArray };
  }, [projects]);
};